
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import i18n from '../language/i18n';
import { useTranslation } from "react-i18next";
import { FaAngleDown } from 'react-icons/fa';

function Header() {
    const [bars, setBars] = useState(false);
    const { t } = useTranslation();
    const [showDropdown, setShowDropdown] = useState(false); // dropdown visibility
    // state պահում է current language
    const [currentLang, setCurrentLang] = useState(localStorage.getItem("lang") || "hy");

    // Երբ currentLang փոխվում է, i18n կփոխի լեզուն և re-render կլինի
    useEffect(() => {
        i18n.changeLanguage(currentLang);
    }, [currentLang]);

    const changeLanguage = (lang) => {
        setCurrentLang(lang); // սա trigger է անում re-render
        localStorage.setItem("lang", lang);
        setShowDropdown(false)
    };
    return (
        <header>
            <div className='header1'>
                <ScrollLink to="skizb" smooth duration={500} offset={-80} className='headerlogo'>
                    <img src="image/logo11.jpg" alt="logo" width={46} height={46} />
                    <h2>HGH AGRO DRONES</h2>
                </ScrollLink>

                <section className={bars === false ? 'nav' : 'navBars'}>
                    <li><ScrollLink to="carayutyunner" smooth duration={500} offset={-40}><Link className='link1'>{t("li1")}</Link></ScrollLink></li>
                    <li><ScrollLink to="aboutUs" smooth duration={500} offset={-60}><Link className='link1'>{t("li2")}</Link></ScrollLink></li>
                    <li><ScrollLink to="aravelutyunner" smooth duration={500} offset={-60}><Link className='link1'>{t("li3")}</Link></ScrollLink></li>
                    <li><ScrollLink to="kap" smooth duration={500} offset={-60}><Link className='link1'>{t("li4")}</Link></ScrollLink></li>
                    <div>
                        <div className='languageNav' >

                            <div className='vernagirSel'>
                                <h1>{t("Sel")}</h1>
                            </div>
                            <div className='languagesNavOnly' >
                                <div onClick={() => { changeLanguage("hy"); setBars(false) }} className='languagesSelNav'>AM</div>
                                <div onClick={() => { changeLanguage("ru"); setBars(false) }} className='languagesSelNav'>RU</div>
                                <div onClick={() => { changeLanguage("en"); setBars(false) }} className='languagesSelNav'>EN</div>

                            </div>


                        </div>
                    </div>



                </section>
                <div className='headernerbut' >

                    <button className='headerBtn' onClick={() => { window.location.href = "tel:+37433809009" }}>


                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                        <p>{t("zang")}</p>

                    </button>
                    <div className='language' >
                        <button className='langSkizb' onClick={() => setShowDropdown(!showDropdown)}>
                            {currentLang === "hy" ? "AM" : currentLang === "ru" ? "RU" : "EN"}
                            <FaAngleDown />
                        </button>

                        {showDropdown && (
                            <div className='lang' >
                                <div onClick={() => changeLanguage("hy")} className='languagesSel'>AM</div>
                                <div onClick={() => changeLanguage("ru")} className='languagesSel'>RU</div>
                                <div onClick={() => changeLanguage("en")} className='languagesSel'>EN</div>
                            </div>
                        )}
                    </div>



                </div>
                <div >
                    <button onClick={() => { setBars(!bars) }} className={bars === false ? "btnBars" : "btnClose"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M4 5h16"></path><path d="M4 12h16"></path><path d="M4 19h16"></path></svg>
                    </button>
                    <button onClick={() => { setBars(!bars) }} className={bars === false ? 'btnClose' : 'btnBars'} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ariaHidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                    </button>

                </div>






            </div >
        </header >
    )
}

export default Header
